<template>
  <div class="product-page container">
    <block-breadcrumbs :items="breadcrumbs" />
    <product-card />
    <product-info
      v-show="!adaptive.isMobile"
      :product-code="PRODUCT.code"
      :city-name="CITY.name"
      :active-sku="ACTIVE_SKU"
      class="product-page__info"
    />
    <product-gallery-recomendations
      class="product-page__recomendations"
      :product-ids="[PRODUCT.id]"
    />
    <product-gallery-recently-viewed />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { productGtmEvents } from '@/gtm/product';

/* Components */
import blockBreadcrumbs from '../components/breadcrumbs/breadcrumbs';
import ProductCard from '../components/product/product-card.vue';
import ProductInfo from '../components/product/product-info.vue';
import ProductGalleryRecentlyViewed from '@/components/product-gallery-recently-viewed/product-gallery-recently-viewed.vue';
import ProductGalleryRecomendations from '@/components/product-gallery-recomendations/product-gallery-recomendations.vue';

export default {
  name: 'product',

  components: {
    blockBreadcrumbs,
    ProductCard,
    ProductInfo,
    ProductGalleryRecentlyViewed,
    ProductGalleryRecomendations,
  },

  inject: ['adaptive'],

  data() {
    return {
      tab: 'description'
    }
  },

  metaInfo() {
    return {
      titleTemplate: t => t,
      title: [
        this.PRODUCT.name,
        `(${this.PRODUCT.code})`,
        'купить за',
        this.PRODUCT.price.discountPrice || this.PRODUCT.price.basePrice,
        'руб. в интернет-магазине FunDay'
      ].join(' '),
      meta: [
        {
          name: 'description',
          content: [
            this.PRODUCT.name,
            this.PRODUCT.code,
            '– цвет ' + this.PRODUCT.color?.name,
            'разных размеров, приобрести в официальном интернет-магазине FunDay. Доставка по всей России.'
          ].join(' '),
          vmid: 'description'
        },
      ],
    }
  },

  computed: {
    ...mapGetters({
      PRODUCT: 'product/item',
      CITY: 'user/city',
      ACTIVE_SKU: 'product/activeSku',
    }),
    ...mapState('product', ['isReviewsAvailable']),

    breadcrumbs() {
      return this.PRODUCT?.breadcrumbs || [];
    },
    productId() {
      return this.$route?.params?.id;
    },
    currentPrice() {
      return this.PRODUCT.price?.discountPrice || this.PRODUCT.price?.basePrice;
    },
  },

  mounted() {
    // Google Tag Manager event
    productGtmEvents.card.viewProductPage({
      productCode: this.PRODUCT?.code,
      productId: this.PRODUCT?.id,
      price: this.currentPrice,
    });
  },

  async created() {
    if (this.$isServer) return;
    // нужны для инициализации инфы в табах/аккордеоне
    await this.getReviewsServiceState();
    if (this.isReviewsAvailable) {
      this.loadProductReviews({ productId: this.productId });
    }
    this.loadFragment({slotName: 'product_delivery'});
  },

  methods: {
    ...mapActions({
      loadProduct: 'product/loadProduct',
      loadFragment: 'staticPages/loadStaticFragments',
      loadProductReviews: 'product/loadProductReviews',
      loadAvailabilityList: 'product/loadAvailabilityList',
      getReviewsServiceState: 'product/getReviewsServiceState',
    })
  },

  serverPrefetch() {
    // бывают ошибки на дин стенде
    return Promise.allSettled([
      this.loadProduct(),
      this.loadAvailabilityList(),
    ]);
  },
};
</script>

<style lang="scss">
.product-page__info {
  @include breakpoint("tablet") {
    margin-bottom: 56px;
  }

  @include breakpoint("desktop") {
    margin-bottom: 72px;
  }
}

.product-page__recomendations {
  margin-bottom: -16px;
  @include breakpoint("tablet") {
    margin-bottom: 35px;
  }
}
</style>
